interface LensDetails {
  zoom?: number;
  width?: number;
  height?: number;
}

const oneDecimal = (n: number) => String(Math.round(n * 10) / 10);

function zoomPart(zoom: number): string {
  if (zoom < 0.9) return `${oneDecimal(zoom)}× ultra-wide`;
  if (zoom > 1.4) return `${oneDecimal(zoom)}× telephoto`;
  return `${oneDecimal(zoom)}×`;
}

function megapixels(width: number, height: number): string {
  const mp = (width * height) / 1e6;
  return mp < 1 ? `${oneDecimal(mp)} MP` : `${Math.round(mp)} MP`;
}

/** The line under a lens: zoom against the main camera, megapixels and pixel size, whichever are known. */
export function lensSubtitle(d: LensDetails): string {
  const parts: string[] = [];
  if (d.zoom !== undefined) parts.push(zoomPart(d.zoom));
  if (d.width && d.height) {
    parts.push(megapixels(d.width, d.height), `${d.width}×${d.height}`);
  }
  return parts.join(' · ');
}

/** Reads a bridge's `"<w>x<h>"` size. */
export function parseSize(s: string | undefined): { width: number; height: number } | undefined {
  const m = /^(\d+)x(\d+)$/.exec(s ?? '');
  if (!m) return undefined;
  const [width, height] = [Number(m[1]), Number(m[2])];
  return width > 0 && height > 0 ? { width, height } : undefined;
}
